$(document).ready(function() {
  if(document.querySelector('#birthday')){
  $("#birthday").flatpickr({
    enableTime: true,
    dateFormat: "F, d Y H:i"
});
  }
  
    function t(t) {
        var o = $(t).offset().top - 85;
        $("html,body").animate({
            scrollTop: o
        }, 500)
    }

    function o() {
        $.each($(".animate"), function(t, o) {
            $(this).shouldAnimate() && ($(this).removeClass("animate"), $(this).addClass("animated"), $(this).addClass($(this).data("animation")))
        })
    }
    $("a[href^=#]").not(".ignore").on("click", function(o) {
        o.preventDefault(), t($(this).attr("href"))
    }), $(document).on("ready", function() {
        $("img:not(.owl-lazy)").Lazy()
    }), $(".share-link").on("click", function(t) {
        t.preventDefault();
        var o = $(this).attr("href");
        window.open(o, "Share", "width=600,height=400")
    }), $(window).on("scroll", function() {
        $(this).scrollTop() > 200 ? $(".to-top").addClass("visible") : $(".to-top").removeClass("visible")
    }), $(document).on("click", ".to-top", function(t) {
        t.preventDefault(), $("body, html").animate({
            scrollTop: 0
        }, 1e3)
    }), $.fn.shouldAnimate = function() {
        var t = $(window),
            o = {
                top: t.scrollTop() - 50,
                left: t.scrollLeft()
            };
        o.right = o.left + t.width(), o.bottom = o.top + t.height();
        var e = this.offset();
        return e.right = e.left + this.outerWidth(), e.bottom = e.top + this.outerHeight(), !(o.right < e.left || o.left > e.right || o.bottom < e.top)
    }, o(), $(document).ready(o), $(document).on("scroll", function() {
        o()
    });
    var e = $(".store-notice").outerHeight() || 0;

    function i() {
        $(this).scrollTop() >= e ? $("body").addClass("fixed-navbar") : $("body").removeClass("fixed-navbar")
    }
    if ($(window).on("scroll", function() {
            i()
        }), $(window).on("resize", function() {
            e = $(".store-notice").outerHeight() || 0
        }), i(), $(document).on("click", ".menu-toggle", function(t) {
            t.preventDefault(), $("body").toggleClass("menu-open")
        }), new Rellax(".rellax", {
            center: !0
        }), $(".add-to-cart-bar-position").length) {
        function a() {
            let t = $(".add-to-cart-bar-position").offset().top - $(".header").height();
            $(this).scrollTop() > t ? $("body").addClass("show-atcb") : $("body").removeClass("show-atcb")
        }
        $(window).on("scroll", function() {
            a()
        }), a(), $(".add-to-cart-bar").on("click", function(o) {
            o.preventDefault(), t("#product-details")
        })
    }
    $(document).on("click", ".cart-toggle", function(t) {
        t.preventDefault(), $("body").toggleClass("cart-open")
    });
    var n = 1;

    function l(t, o) {
        CartJS.cart.items.forEach(o => {
            o.id != t || (n = 0)
        }), CartJS.cart.items_subtotal_price > 100 * o && 1 == n && (n = 0, CartJS.addItem(t))
    }

    function s() {
        $(window).width() >= 768 ? ($(".products-carousel").removeClass("row-flex").addClass("owl-carousel"), $(".products-carousel").owlCarousel({
            lazyLoad: !1,
            loop: !1,
            nav: !0,
            dots: !1,
            autoplay: !1,
            autoplayTimeout: 5e3,
            margin: 10,
            responsive: {
                0: {
                    items: 1
                },
                768: {
                    items: 3
                },
                992: {
                    items: 4
                },
                1440: {
                    items: 5
                }
            },
            navText: ['<div><i class="glyphicon glyphicon-menu-left"></i></div>', '<div><i class="glyphicon glyphicon-menu-right"></i></div>']
        })) : ($(".products-carousel").removeClass("owl-carousel").addClass("row-flex"), $(".products-carousel").owlCarousel("destroy")), $(".nav-categories ul").length && $(".nav-categories ul").hasScrollBar() ? $(".nav-categories button").css("display", "block") : $(".nav-categories button").css("display", "none")
    }
  $(".min-text").hide()
  $('a.btn.btn-primary.disabled.confirm-button').prop('disabled', false).removeClass('disabled')

    function r(t) {
      $(".min-text").hide()
        $('a.btn.btn-primary.disabled.confirm-button').prop('disabled', false).removeClass('disabled')
      //  CartJS.cart.items_subtotal_price > 100 * t ? ($(".confirm-button").removeClass("disabled"), $(".min-text").hide()) : ($(".confirm-button").addClass("disabled"), $(".min-text").show())
    }
    setTimeout(() => {
        //l(34773717713058, 300), 
           r(199)
    }, 420), $(document).on("cart.requestComplete", function(t, o) {
//   console.log(o)
//   o.items.forEach(x=>{
//     if(x.id == '35330580152482'){
//     	$.ajax({
//         url: "https://shopsmj.com/discount/KURE150",
//         type: 'GET',
//         dataType: 'json', // added data type
//         success: function(res) {
//             console.log(res);
//         }
//     });
//     }
//   })
        $(".cart-counter").html(o.item_count), $("body").not(".template-cart").addClass("cart-open"), setTimeout(() => {
            n = 1 
                                                                                                                 //l(34773717713058, 300)
        }, 550), r(199)
    }), $(".home-hero-carousel").owlCarousel({
        items: 1,
        loop: !0,
        nav: !1,
        dots: !0,
        autoplay: !0,
        margin: 0
    }), $.fn.hasScrollBar = function() {
        return this.get(0).scrollWidth > this.width()
    }, $(".btn-scroll-left").click(function() {
        $(".nav-categories ul").animate({
            scrollLeft: "-=45px"
        })
    }), $(".btn-scroll-right").click(function() {
        $(".nav-categories ul").animate({
            scrollLeft: "+=45px"
        })
    }), $(".products-cart-carousel").owlCarousel({
        lazyLoad: !1,
        loop: !1,
        nav: !0,
        dots: !1,
        autoplay: !1,
        autoplayTimeout: 5e3,
        margin: 10,
        items: 2,
        navText: ['<div><i class="glyphicon glyphicon-menu-left"></i></div>', '<div><i class="glyphicon glyphicon-menu-right"></i></div>']
    }), $(".cart-drawer-products form button[type=submit]").on("click", function(t) {
        $(".cart-drawer-inner").animate({
            scrollTop: 0
        })
    }), s(), $(window).on("resize", s), $(".collection-categories .nav li.active").length && $(".collection-categories .nav").scrollLeft($(".collection-categories .nav li.active").offset().left - 50), $(".testimonials-carousel").owlCarousel({
        items: 1,
        loop: !0,
        nav: !0,
        dots: !1,
        autoplay: !0,
        margin: 0,
        navText: ['<div><i class="glyphicon glyphicon-menu-left"></i></div>', '<div><i class="glyphicon glyphicon-menu-right"></i></div>']
    });
    var c = "<ul>";
    if (c += '<li><a href="https://www.facebook.com/sharer/sharer.php?u=' + window.location + '" class="share-link"><i class="fa fa-facebook"></i></a></li>', c += '<li><a href="http://twitter.com/share?url=' + window.location + '" class="share-link"><i class="fa fa-twitter"></i></a></li>', c += "</ul>", $(".product-share-options").append(c), $(".share-link").on("click", function(t) {
            t.preventDefault();
            var o = $(this).attr("href");
            window.open(o, "Share", "width=600,height=400")
        }), $(document).on("click", ".remove-qty", function(t) {
            t.preventDefault();
            let o = $(this).siblings(".qty-input").first(),
                e = o.val();
            e - 1 >= 0 && (o.val(e - 1), o.trigger("change"))
        }), $(document).on("click", ".add-qty", function(t) {
            t.preventDefault();
            let o = $(this).siblings(".qty-input").first(),
                e = parseInt(o.val());
      if(e < parseInt($(this).data('max-qty'))){
            o.val(e + 1), o.trigger("change")
      }
        }), $(".btn-filter").click(function() {
            $(".collection-sidebar").toggleClass("sidebar-open")
        }), $(document).on("click", ".close-sidebar", function() {
            $(".collection-sidebar").removeClass("sidebar-open")
        }), $("#RecoverPassword").click(function(t) {
            t.preventDefault(), $("#customer-login").hide(), $("#customer-password-reset").show()
        }), $("#CancelRecoverPassword").click(function(t) {
            t.preventDefault(), $("#customer-password-reset").hide(), $("#customer-login").show()
        }), $(".nav-tabs").length) {
        var u = document.location.toString();
        u.match("#") && $('.nav-tabs a[href="#' + u.split("#")[1] + '"]').tab("show")
    }
  $('.js.product-form__input input').on('change', function(){
    let selected_value = $(this).val()
    $('.single-option-selector option[value="'+selected_value+'"]').prop('selected', true).trigger('change')

  })
}), $(function() {
    $(".general-scroll-down span a").on("click", function(t) {
        t.preventDefault(), $("html, body").animate({
            scrollTop: $($(this).attr("href")).offset().top - 150
        }, 500, "linear")
    }), setTimeout(() => {
        $("#scroll-here").show()
    }, 800)
});

